<template>
  <BasicTemplate>
    <h3>
      <router-link to="/metadata-management">Metadata Templates</router-link>
      /
      New Meta Template
    </h3>

    <v-card class="ma-4 pa-4">
      <v-card-title>
        <h2>Create Meta Template</h2>
      </v-card-title>
      <v-card-text>
        <v-alert v-if="error" type="error" dense class="mb-3">
          {{ error }}
        </v-alert>
        <v-text-field v-model="form.name" label="Name *" :rules="[rules.required]" required />
        <v-textarea v-model="form.description" label="Description" rows="3" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$router.push('/metadata-management')">Cancel</v-btn>
        <v-btn color="primary" :disabled="!canSave" :loading="saving" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../templates/basic.vue';

export default {
  name: 'MetadataManagementNew',
  components: { BasicTemplate },
  data() {
    return {
      form: {
        name: '',
        description: '',
      },
      saving: false,
      error: '',
      rules: {
        required: value => !!value || 'Required.',
      },
    };
  },
  computed: {
    canSave() {
      return !!this.form.name;
    },
  },
  methods: {
    async save() {
      this.error = '';
      this.saving = true;
      try {
        await this.$msal.ensureAuthenticated();
        const created = await this.$gameApi.post('/meta-templates', {
          name: this.form.name,
          description: this.form.description,
        });
        this.$swal.fire({ icon: 'success', title: 'Template created.', timer: 1500, showConfirmButton: false });
        if (created?.id) {
          this.$router.push(`/metadata-management/${created.id}`);
          return;
        }
        this.$router.push('/metadata-management');
      } catch (error) {
        this.error = error?.message || 'Error creating template';
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
